'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var getHost = require('./getHost-bdfdb786.js');
var http = require('./http-bb56b50d.js');
require('@mkt-common/shopee-common');
var BASE_DOMAIN_ALL = {
  sg: 'shopee.sg',
  my: 'shopee.com.my',
  th: 'shopee.co.th',
  tw: 'shopee.tw',
  vn: 'shopee.vn',
  id: 'shopee.co.id',
  ph: 'shopee.ph',
  br: 'shopee.com.br'
};
function getDomain(_a) {
  var _b = _a.environment,
    environment = _b === void 0 ? 'live' : _b,
    _c = _a.country,
    country = _c === void 0 ? 'sg' : _c;
  environment = environment.replace(/"/g, '');
  country = country.replace(/"/g, '');
  var domainPrefix = environment === 'live' ? '' : environment === 'liveish' ? 'live-test.' : environment + ".";
  return "" + domainPrefix + BASE_DOMAIN_ALL[country];
}
var ChatMsgType = {
  CHAT_REQUEST_SUCCESS: 'ChatRequestSuccess',
  QUEUE_UPDATE: 'QueueUpdate',
  CHAT_ESTABLISHED: 'ChatEstablished',
  CHAT_MESSAGE: 'ChatMessage',
  CHAT_ENDED: 'ChatEnded',
  CHAT_REQUEST_FAIL: 'ChatRequestFail',
  CHAT_TRANSFER: 'AgentDisconnect_ChatbotV2',
  AGENT_DISCONNECT: 'AgentDisconnect',
  AGENT_TYPING: 'AgentTyping',
  AGENT_NOT_TYPING: 'AgentNotTyping'
};
var extraTime = 5; // 5s
var GetMsgResCode = {
  SUCCESS: 0,
  TIMEOUT: 204,
  BAD_REQ: 400,
  ILLEGAL: 403,
  CONFLICT: 409,
  TOO_FREQUENT: 429,
  NOT_LOGIN: 1003,
  SESSION_ID_MISSING: 1004,
  TEMPORARY_ERROR: 40000,
  SESSION_EXPIRED: 40001,
  SESSION_ID_WRONG: 40006,
  CANCEL_ORDER_FAILED: 40008,
  LIVE_OFFLINE_ERROR_CODE: 60001,
  SEND_FAIL: 60002,
  UNEXPECTED_CHAT_END: 2001,
  TIMEOUT_ERROR: 'TIMEOUT',
  NETWORK_ERROR: 'NETWORK_ERROR',
  SERVER_ERROR: 'SERVER_ERROR'
};
exports.AgentEndReason = void 0;
(function (AgentEndReason) {
  AgentEndReason["CHATBOT_SYSTEM_INFORM"] = "chatbot_system_inform";
})(exports.AgentEndReason || (exports.AgentEndReason = {}));
var PrechatDetailsLabels = {
  requestorName: 'Requestor Name',
  requestorPhone: 'Requestor Phone',
  requestorEmail: 'Requestor Email',
  userName: 'User Name',
  userID: 'User ID',
  subject: 'Subject',
  caseCountry: 'Case Country',
  contactType: 'Contact Type',
  shopeeChatKey: 'Shopee Chat Key',
  lastArticleURL: 'Last Article URL',
  lastArticleID: 'Last Article ID',
  chatbotArticle: 'Chatbot article',
  chatbotTaskbot: 'Chatbot taskbot',
  shopeeChatbotSessionID: 'Shopee_Chatbot_Session_Id',
  shopeeAppVersion: 'Shopee App Version',
  chatbotHistory: 'Chatbot history',
  orderSN: 'Order SN',
  // loyaltyTier: 'Customer Loyalty Tier',
  loyaltyTierCode: 'Customer Loyalty Tier Code',
  userType: 'User Type',
  enquiryType: 'Enquiry Type',
  from: 'Entry Point',
  // SF新增
  userIDReadonly: 'User Id readonly',
  authenticatedUser: 'Shopee Authenticated User',
  returnSN: 'Return SN',
  returnID: 'Return ID'
  // end
};

var PRE_CHAT_ENTITIES = [{
  saveToTranscript: 'Case',
  linkToEntityName: null,
  showOnCreate: true,
  linkToEntityField: null,
  entityName: 'Case',
  entityFieldsMaps: [{
    isExactMatch: false,
    label: 'Requestor Name',
    doFind: false,
    fieldName: 'Shopee_ID_Requestor_Name__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Requestor Phone',
    doFind: false,
    fieldName: 'Shopee_ID_Requestor_Phone__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Requestor Email',
    doFind: false,
    fieldName: 'Shopee_ID_Requestor_Email__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'User Name',
    doFind: false,
    fieldName: 'Shopee_ID_User_Name__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'User ID',
    doFind: false,
    fieldName: 'Shopee_ID_User_Id__c',
    doCreate: true
  },
  // SF新增
  {
    isExactMatch: false,
    label: 'User Id readonly',
    doFind: false,
    fieldName: 'Shopee_ID_User_Id_readonly__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Shopee Authenticated User',
    doFind: false,
    fieldName: 'Shopee_Authenticated_User__c',
    doCreate: true
  },
  // end
  {
    isExactMatch: false,
    label: 'Subject',
    doFind: false,
    fieldName: 'Subject',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Case Country',
    doFind: false,
    fieldName: 'Shopee_ID_Case_Country__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Contact Type',
    doFind: false,
    fieldName: 'Origin',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Shopee Chat Key',
    doFind: false,
    fieldName: 'Shopee_Chat_Key__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Shopee App Version',
    doFind: false,
    fieldName: 'Shopee_App_Version__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Last Article URL',
    doFind: false,
    fieldName: 'Shopee_ID_Last_Article_URL__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Last Article ID',
    doFind: false,
    fieldName: 'Shopee_ID_Last_Article_ID__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Chatbot article',
    doFind: false,
    fieldName: 'Shopee_Chatbot_Article__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Chatbot taskbot',
    doFind: false,
    fieldName: 'Shopee_Chatbot_Taskbot__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Chatbot history',
    doFind: false,
    fieldName: 'Shopee_Chatbot_History__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Shopee_Chatbot_Session_Id',
    doFind: false,
    fieldName: 'Shopee_Chatbot_Session_Id__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Order SN',
    doFind: false,
    fieldName: 'Shopee_ID_Order_ID__c',
    doCreate: true
  },
  // {
  //   'isExactMatch': false,
  //   'label': 'Customer Loyalty Tier',
  //   'doFind': false,
  //   'fieldName': 'Customer_Loyalty_Tier__c',
  //   'doCreate': true
  // },
  {
    isExactMatch: false,
    label: 'Customer Loyalty Tier Code',
    doFind: false,
    fieldName: 'Customer_Loyalty_Tier_Code__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'User Type',
    doFind: false,
    fieldName: 'Shopee_ID_Seller_Buyer__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Enquiry Type',
    doFind: false,
    fieldName: 'Shopee_ID_Enquiry_Type__c',
    doCreate: true
  }, {
    isExactMatch: false,
    label: 'Entry Point',
    doFind: false,
    fieldName: 'Chat_Category__c',
    doCreate: true
  }]
}];
var GET_MESSAGES_TIMEOUT = 'GET_MESSAGES_TIMEOUT';
var MAX_RETRY_GET_MESSAGES_COUNT = 7;
var EMMIT_ERROR_THRESHOLD = 3;
var LOYALTY_TIER_CODES = [0, 10, 20, 30, 40];
var PARTIALLY_GRAY_TO_INHOUSE_REGIONS = [getHost.COUNTRIES.SG, getHost.COUNTRIES.MX, getHost.COUNTRIES.BR, getHost.COUNTRIES.CO, getHost.COUNTRIES.CL, getHost.COUNTRIES.AR, getHost.COUNTRIES.ID];
var FULLY_GRAY_TO_INHOUSE_ENTRY_POINTS = [http.GRAY_RELEASE_CONFIG_ENTRY_POINT.Cncb, http.GRAY_RELEASE_CONFIG_ENTRY_POINT.CncbMain, http.GRAY_RELEASE_CONFIG_ENTRY_POINT.BankMePage, http.GRAY_RELEASE_CONFIG_ENTRY_POINT.BankHelpCenter];
var PARTIALLY_GRAY_TO_INHOUSE_ENTRY_POINTS = [http.GRAY_RELEASE_CONFIG_ENTRY_POINT.MePage, http.GRAY_RELEASE_CONFIG_ENTRY_POINT.HelpCentre, http.GRAY_RELEASE_CONFIG_ENTRY_POINT.Other];
var USE_LOCATION_HOSTNAME_ENTRY_POINTS = [http.GRAY_RELEASE_CONFIG_ENTRY_POINT.BankMePage, http.GRAY_RELEASE_CONFIG_ENTRY_POINT.BankHelpCenter];
exports.Platform = void 0;
(function (Platform) {
  Platform["Mobile"] = "Moblie";
  Platform["PC"] = "PC";
})(exports.Platform || (exports.Platform = {}));
var ERROR_TIME_OUT = 10000;
exports.MSG_TYPES = void 0;
(function (MSG_TYPES) {
  MSG_TYPES["SESSION_CLOSED"] = "SESSION_CLOSED";
  MSG_TYPES["CHASING_USER_CLOSE_SESSION"] = "CHASING_USER_CLOSE_SESSION";
  MSG_TYPES["CHASING_TIMEOUT_CLOSE_SESSION"] = "CHASING_TIMEOUT_CLOSE_SESSION";
  MSG_TYPES["USER_CLOSE_SESSION"] = "USER_CLOSE_SESSION";
  MSG_TYPES["CS_CLOSE_SESSION"] = "CS_CLOSE_SESSION";
  MSG_TYPES["CANCEL_QUEUE"] = "CANCEL_QUEUE";
  MSG_TYPES["TEXT"] = "TEXT";
  MSG_TYPES["IMG"] = "IMG";
  MSG_TYPES["VID"] = "VID";
  MSG_TYPES["FILE"] = "FILE";
  MSG_TYPES["NEW_SESSION"] = "NEW_SESSION";
  MSG_TYPES["QUEUING"] = "QUEUING";
  MSG_TYPES["CS_JOINED"] = "CS_JOINED";
  MSG_TYPES["AGENT_TYPING"] = "AGENT_TYPING";
  MSG_TYPES["TRANSFER_SESSION"] = "TRANSFER_SESSION";
  MSG_TYPES["SESSION_CLOSE_TIMEOUT"] = "SESSION_CLOSE_TIMEOUT";
  MSG_TYPES["QUEUING_CHECK_NOTICE"] = "QUEUING_CHECK_NOTICE";
  MSG_TYPES["EVENT_SESSION_CLOSED"] = "EVENT_SESSION_CLOSED";
  MSG_TYPES["SYSTEM_NOTICE"] = "SYSTEM_NOTICE";
  MSG_TYPES["REQUEST_ORDER"] = "REQUEST_ORDER";
  MSG_TYPES["SERVICE_ASSISTANT"] = "SERVICE_ASSISTANT";
  MSG_TYPES["NO_VALID_AGENT"] = "NO_VALID_AGENT";
})(exports.MSG_TYPES || (exports.MSG_TYPES = {}));
var DEFAULT_ENTRY_POINT = 1; // Shopee mePage

exports.BASE_DOMAIN_ALL = BASE_DOMAIN_ALL;
exports.ChatMsgType = ChatMsgType;
exports.DEFAULT_ENTRY_POINT = DEFAULT_ENTRY_POINT;
exports.EMMIT_ERROR_THRESHOLD = EMMIT_ERROR_THRESHOLD;
exports.ERROR_TIME_OUT = ERROR_TIME_OUT;
exports.FULLY_GRAY_TO_INHOUSE_ENTRY_POINTS = FULLY_GRAY_TO_INHOUSE_ENTRY_POINTS;
exports.GET_MESSAGES_TIMEOUT = GET_MESSAGES_TIMEOUT;
exports.GetMsgResCode = GetMsgResCode;
exports.LOYALTY_TIER_CODES = LOYALTY_TIER_CODES;
exports.MAX_RETRY_GET_MESSAGES_COUNT = MAX_RETRY_GET_MESSAGES_COUNT;
exports.PARTIALLY_GRAY_TO_INHOUSE_ENTRY_POINTS = PARTIALLY_GRAY_TO_INHOUSE_ENTRY_POINTS;
exports.PARTIALLY_GRAY_TO_INHOUSE_REGIONS = PARTIALLY_GRAY_TO_INHOUSE_REGIONS;
exports.PRE_CHAT_ENTITIES = PRE_CHAT_ENTITIES;
exports.PrechatDetailsLabels = PrechatDetailsLabels;
exports.USE_LOCATION_HOSTNAME_ENTRY_POINTS = USE_LOCATION_HOSTNAME_ENTRY_POINTS;
exports.extraTime = extraTime;
exports.getDomain = getDomain;